"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreImportToJSON = exports.StoreImportFromJSONTyped = exports.StoreImportFromJSON = exports.instanceOfStoreImport = exports.StoreImportCreatedViaEnum = exports.StoreImportStatusEnum = void 0;
var runtime_1 = require("../runtime");
var StoreImportCampaignsInner_1 = require("./StoreImportCampaignsInner");
var StoreImportOwnerDetail_1 = require("./StoreImportOwnerDetail");
var StoreImportStoreConfig_1 = require("./StoreImportStoreConfig");
var StoreImportStoreProductsInner_1 = require("./StoreImportStoreProductsInner");
/**
 * @export
 */
exports.StoreImportStatusEnum = {
    Draft: 'draft',
    Open: 'open',
    Closed: 'closed'
};
/**
 * @export
 */
exports.StoreImportCreatedViaEnum = {
    Internal: 'internal',
    SelfServe: 'self_serve',
    Groups: 'groups'
};
/**
 * Check if a given object implements the StoreImport interface.
 */
function instanceOfStoreImport(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoreImport = instanceOfStoreImport;
function StoreImportFromJSON(json) {
    return StoreImportFromJSONTyped(json, false);
}
exports.StoreImportFromJSON = StoreImportFromJSON;
function StoreImportFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'createdVia': !(0, runtime_1.exists)(json, 'created_via') ? undefined : json['created_via'],
        'urlSlug': !(0, runtime_1.exists)(json, 'url_slug') ? undefined : json['url_slug'],
        'ownerDetail': !(0, runtime_1.exists)(json, 'owner_detail') ? undefined : (0, StoreImportOwnerDetail_1.StoreImportOwnerDetailFromJSON)(json['owner_detail']),
        'campaigns': !(0, runtime_1.exists)(json, 'campaigns') ? undefined : (json['campaigns'] === null ? null : json['campaigns'].map(StoreImportCampaignsInner_1.StoreImportCampaignsInnerFromJSON)),
        'storeProducts': !(0, runtime_1.exists)(json, 'store_products') ? undefined : (json['store_products'].map(StoreImportStoreProductsInner_1.StoreImportStoreProductsInnerFromJSON)),
        'storeConfig': !(0, runtime_1.exists)(json, 'store_config') ? undefined : (0, StoreImportStoreConfig_1.StoreImportStoreConfigFromJSON)(json['store_config']),
    };
}
exports.StoreImportFromJSONTyped = StoreImportFromJSONTyped;
function StoreImportToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'status': value.status,
        'created_via': value.createdVia,
        'url_slug': value.urlSlug,
        'owner_detail': (0, StoreImportOwnerDetail_1.StoreImportOwnerDetailToJSON)(value.ownerDetail),
        'campaigns': value.campaigns === undefined ? undefined : (value.campaigns === null ? null : value.campaigns.map(StoreImportCampaignsInner_1.StoreImportCampaignsInnerToJSON)),
        'store_products': value.storeProducts === undefined ? undefined : (value.storeProducts.map(StoreImportStoreProductsInner_1.StoreImportStoreProductsInnerToJSON)),
        'store_config': (0, StoreImportStoreConfig_1.StoreImportStoreConfigToJSON)(value.storeConfig),
    };
}
exports.StoreImportToJSON = StoreImportToJSON;
